module.exports = __webpack_public_path__ + "img/mono-wheel-robot.3ee1c728.svg";